export const GET_TERRITORY_TOTAL_POSTS_LOG = {
  from: 'src > pages > SearchTerritoriesPage > components > WinninTopicsTab > components > TerritoryInSearch',
  name: 'Gets a territorys total posts',
  message: 'Obtain a territorys total posts.',
}

export const CREATE_NICHES_BY_SEARCH_LOG = {
  from: 'src > pages > SearchTerritoriesPage > components > WinninTopicsTab > components > TerritoriesInSearchLIst',
  name: 'Gets a searchs territories',
  message: 'Obtain a searchs territories.',
}
